import React from "react";

const ArrowDropDownIcon = ({ width = "24", height = "24", className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className}>
    <path d="m11.898 14.627-5-5h10l-5 5Z" />
  </svg>
);

export default ArrowDropDownIcon;
